import React, { useEffect, useState } from "react";
import { DatePicker } from "antd";
import moment from "moment";
import AppInput from "../../../../components/AppInput";
import VoyageDetails from "../../../../components/VoyageDetails";
import { useParams } from "react-router-dom";
import { post } from "../../../../services/services";
import { ApiURL } from "../../../../services/apiConstants";

function ViewBunkerFuelChangeover() {
  const { fuel_id } = useParams();
  const [staff_dashboard, set_staff_dashboard] = useState([]);
  const [form, setForm] = useState({
    changeOverCompletion: null,
    shipPositionCompletion: "",
    lowSulphurQtyAfter: "",
    ecaEntry: null,
    ecaExit: null,
    changeOverToHighSulphur: null,
    shipPositionHighSulphur: "",
    lowSulphurQtyBefore: "",
    remarks: "",
    chiefEngSign: "",
  });

  useEffect(() => {
    const staff_dashboards = localStorage.getItem("staff_dashboard");
    try {
      if (staff_dashboards) {
        const parsedData = JSON.parse(staff_dashboards);
        set_staff_dashboard(parsedData);
        VIEW_FUEL_CHARGEOVER_DETAILS(parsedData);
      }
    } catch (err) {
      console.error("Error parsing staff_dashboard:", err);
    }
  }, []);

  const VIEW_FUEL_CHARGEOVER_DETAILS = async (voyage_data) => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("voyage_id", voyage_data?.voyage_details?.[0]?.id);
      FORM_DATA.append("record_id", atob(fuel_id));
      FORM_DATA.append("request_type", "view");

      const response = await post(ApiURL?.view_bunker_fuel_chargerover_st_fcr, FORM_DATA);

      if (response?.status === true) {
        const data = response?.data;
        const mappedData = {
          changeOverCompletion: data?.date_and_time_completion
            ? moment(data.date_and_time_completion)
            : null,
          shipPositionCompletion: data?.ship_position || "",
          lowSulphurQtyAfter: data?.low_sulphur_quality_completion || "",
          ecaEntry: data?.date_and_time_entry_eca
            ? moment(data.date_and_time_entry_eca)
            : null,
          ecaExit: data?.date_and_time_exit_eca
            ? moment(data.date_and_time_exit_eca)
            : null,
          changeOverToHighSulphur: data?.date_and_time_changeover_high_sulphur
            ? moment(data.date_and_time_changeover_high_sulphur)
            : null,
          shipPositionHighSulphur: data?.ship_position_high_sulphur || "",
          lowSulphurQtyBefore: data?.low_sulphur_quality_start || "",
          remarks: data?.remarks || "",
          chiefEngSign: data?.chief_eng_name_sign || "",
        };

        setForm(mappedData);
      } else {
        console.error("Failed to fetch bunker fuel changeover details:", response);
      }
    } catch (error) {
      console.error("Error in VIEW_FUEL_CHARGEOVER_DETAILS:", error);
    }
  };

  return (
    <>
      <VoyageDetails staff_dashboard={staff_dashboard?.voyage_details} />
      <div className="white-container">
        <h3>View Fuel Changeover Record</h3>
        <br />

        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>Date & Time of Completion (Low Sulphur)</label>
              <DatePicker
                showTime
                value={form.changeOverCompletion}
                style={{ width: "100%" }}
                format="YYYY-MM-DD HH:mm:ss"
                disabled
              />
            </div>
          </div>
          <div className="col-6">
            <AppInput
              label="Ship's Position (Completion)"
              value={form.shipPositionCompletion}
              disabled
            />
          </div>
        </div>

        <div className="row">
          <div className="col-6">
            <AppInput
              label="Low Sulphur Quantity at Completion (Tank ID/m3)"
              value={form.lowSulphurQtyAfter}
              disabled
            />
          </div>
        </div>

        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>Date & Time of Entry into ECA-Sox</label>
              <DatePicker
                showTime
                value={form.ecaEntry}
                style={{ width: "100%" }}
                format="YYYY-MM-DD HH:mm:ss"
                disabled
              />
            </div>
          </div>
          <div className="col-6">
            <div className="input-box">
              <label>Date & Time of Exit from ECA-Sox</label>
              <DatePicker
                showTime
                value={form.ecaExit}
                style={{ width: "100%" }}
                format="YYYY-MM-DD HH:mm:ss"
                disabled
              />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>Date & Time of Changeover to High Sulphur</label>
              <DatePicker
                showTime
                value={form.changeOverToHighSulphur}
                style={{ width: "100%" }}
                format="YYYY-MM-DD HH:mm:ss"
                disabled
              />
            </div>
          </div>
          <div className="col-6">
            <AppInput
              label="Ship's Position (High Sulphur Start)"
              value={form.shipPositionHighSulphur}
              disabled
            />
          </div>
        </div>

        <div className="row">
          <div className="col-6">
            <AppInput
              label="Low Sulphur Quantity at Start (Tank ID/m3)"
              value={form.lowSulphurQtyBefore}
              disabled
            />
          </div>
        </div>

        <div className="row">
          <div className="col-6">
            <AppInput label="Remarks" value={form.remarks} disabled />
          </div>
          <div className="col-6">
            <AppInput
              label="Chief Eng. Name & Digital Signature"
              value={form.chiefEngSign}
              disabled
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default ViewBunkerFuelChangeover;
